import { render, staticRenderFns } from "./ListaAcoes.vue?vue&type=template&id=37d7fd33&scoped=true&"
import script from "./ListaAcoes.vue?vue&type=script&lang=js&"
export * from "./ListaAcoes.vue?vue&type=script&lang=js&"
import style0 from "./ListaAcoes.vue?vue&type=style&index=0&id=37d7fd33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7fd33",
  null
  
)

export default component.exports